import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.css']
})
export class SignUpComponent implements OnInit {
  exists: boolean = false;
  invalid:boolean = false;
  logo = '';
  text = '';
  cloading = true;
  passField = true;
  constructor(
    private router: Router,
    private apiService: ApiService,
    public translations: TranslationService
  ) { }
  
  signupForm = new FormGroup({
    firstname: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required])
  });

  ngOnInit() {
    this.apiService.getClient().subscribe((res: any) => {
      this.cloading = false;
      if (res.data.signupImage) {
        this.logo = res.data.signupImage;
      }
      if (res.data.signupQuote) {
        this.text = res.data.signupQuote;
      }
    });
  }

  togglePassword() {
    this.passField = !this.passField;
  }

  getBackgroundUrl() {
    if(this.cloading){
      return '';
    }
    if (this.logo) {
      return this.logo;
    } else {
      return 'https://www.sundaypost.com/wp-content/uploads/sites/13/2019/06/iStock-883703976-554x372.jpg';
    }
  }

  get firstname() { return this.signupForm.get('firstname'); }
  get lastname() { return this.signupForm.get('lastname'); }
  get email() { return this.signupForm.get('email'); }
  get password() { return this.signupForm.get('password'); }


  change() {
    this.exists = false;
  }

  submit() {
    this.invalid = false;
    if (!this.signupForm.valid) {
      Object.keys(this.signupForm.controls).forEach(key => {
        this.signupForm.controls[key].markAsDirty();
      });
      this.invalid = true;
      return;
    }
    this.apiService.signUp(this.signupForm.value).subscribe((res: any) => {
      this.apiService.login(this.signupForm.value).subscribe((res: any) => {
        localStorage.setItem('lunge_front', res.data);
        this.router.navigate(['/questions-answer']);
      });
    }, err => {
      this.exists = true;
    });
  }

}
